/**
 * Step 5 — Budget Settings
 *
 * Focuses solely on the Budget Settings tab from Project Settings.
 * Budget mode is a critical one-time decision — highlighted with a warning nudge.
 */

import { StepWrapper } from '../StepWrapper';
import SettingsProject from '@/pages/settings-project';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step4BudgetSettings({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Budget mode is a one-time system-wide decision — choose carefully before creating any projects."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-foreground">Budget Settings</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Choose how budgets are tracked across all projects. This setting is very difficult to change once budget data exists.
        </p>
      </div>
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsProject defaultTab="budget-settings" />
      </div>
    </StepWrapper>
  );
}
